<template>
  <span class="tab-dot" :class="{ 'tab-dot--specific': isSpecific }"></span>
</template>

<script>
export default {
  props: {
    isSpecific: Boolean
  }
}
</script>

<style lang="scss" scoped>
.tab-dot {
  display: inline-block;
  height: 6px;
  width: 6px;
  background: $primary;
  border-radius: 9px;
  margin-left: 4px;

  &--specific {
    background: $secondary;
  }
}
</style>